import { render, staticRenderFns } from "./PlaysTypeSelector.vue?vue&type=template&id=38997144&"
import script from "./PlaysTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PlaysTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PlaysTypeSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports